module.exports = __webpack_public_path__ + "img/home-poster.a5ec4e43.png";